import { SvgIcon, SvgIconBaseProps } from '@honeycomb/ui-core';
import * as React from 'react';

export function FacebookIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 40 40">
            <g fill="none" fillRule="evenodd">
                <path
                    d="M5.714 0h28.572A5.715 5.715 0 0 1 40 5.714v28.572A5.715 5.715 0 0 1 34.286 40H5.714A5.715 5.715 0 0 1 0 34.286V5.714A5.715 5.715 0 0 1 5.714 0"
                    fill="#0D81BD"
                />
                <path
                    d="M25.396 19.573h-3.768v13.842h-5.744V19.573h-2.731v-4.851h2.731v-3.155a5.34 5.34 0 0 1 5.744-5.744h4.239v4.714h-3.061a1.154 1.154 0 0 0-1.225 1.319v2.866h4.286l-.471 4.851z"
                    fill="#FFF"
                />
            </g>
        </SvgIcon>
    );
}
